import { components } from '@doltech/dto';
import { components as pageMntDefinitions } from '@doltech/pageManagement/dto';
import { SkillEnum } from '@doltech/utils/lib/constants';
import { useStore } from 'mobx-store-provider';

import { TestResultStore } from './test-result.store';

export const getInitializeTestResultStore = (data) => {
  const result: any = {};
  result.initialed = true;

  result.createdAt = data.createdAt;
  result.id = data.id;
  result.lastModifiedAt = data.lastModifiedAt;
  result.testType = data.testType as any;
  switch (data.testType) {
    case 'FULL_TEST': {
      const testData: components['schemas']['UserFullTestDTO'] = data;
      result.bookCover = testData.test?.coverImage?.url;
      result.name = testData.test.name;
      result.skill = testData.test.skill as SkillEnum;
      result.totalDuration = testData.test.totalDuration * 1000;
      result.totalSections = testData.testSections.length;
      result.testSections = testData.testSections || [];
      break;
    }
    case 'PRACTICE_TEST': {
      const testData: components['schemas']['UserPracticeTestDTO'] = data;
      result.bookCover = testData.testSection?.coverImage?.url;
      result.name = testData.testSection.name;
      result.skill = testData.testSection.skill as SkillEnum;
      result.totalDuration = testData.testSection.duration * 1000;
      result.totalSections = 1;
      result.testSections = [testData.testSection];
      break;
    }
    default:
  }

  const pageData = (data as pageMntDefinitions['schemas']['TestDetailDTO'])?.pages || [];

  result.seoPage = pageData as any;
  result.testResults = data?.testResult;

  return result;
};

// Export hook.tsx to use
export const useTestResultStore = () => {
  return useStore(TestResultStore);
};
